import { render, staticRenderFns } from "./StarCellRenderer.vue?vue&type=template&id=bce8aec2&"
import script from "./StarCellRenderer.vue?vue&type=script&lang=js&"
export * from "./StarCellRenderer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports